import { ArrowDownThin, HelpCircle } from '@ori-ui/icons';
import { styled, CircularProgress, Typography } from '@ori-ui/mui';

export const RootContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));

export const StyledRequiredDocument = styled('div')(({ theme }) => ({
  color: theme.palette.error.dark,
}));

export const StyledDivHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  marginTop: theme.spacing(6),
}));

export const StyledHelpCircle = styled(HelpCircle)(({ theme }) => ({
  marginRight: theme.spacing(3),
  color: theme.palette.grey[300],
  fontSize: '29px',
}));

export const StyledLabel = styled('span')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
}));

export const StyledList = styled('ul')(({ theme }) => ({
  margin: 0,
  padding: 0,
  listStyle: 'none',
}));

export const StyledListPending = styled('ul')(({ theme }) => ({
  margin: 0,
  padding: 0,
  listStyle: 'none',
  position: 'relative',
  zIndex: 2,
  overflow: 'hidden',
  borderRadius: '5px',
  boxShadow: '0 0 7px 0 rgba(0, 0, 0, 0.3)',
}));

export const StyledDivWrapper = styled('div')<{ ownerState: { hasDocuments?: boolean } }>(
  ({ theme, ownerState: { hasDocuments = false } }) => ({
    marginBottom: hasDocuments ? theme.spacing(4) : theme.spacing(0),
    position: 'relative',
  }),
);

export const StyledDivUploader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingBottom: theme.spacing(4),
}));

export const StyledDivHistory = styled('div')(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.grey[200]}`,
}));

export const StyledExpanedIcon = styled(ArrowDownThin)(({ theme }) => ({
  flexDirection: 'row-reverse',
  padding: '5px 10px',
  transition: 'transform 0.3s ease-out',
  fontSize: '22px',
  lineHeight: '23px',
  margin: '0 5px',
  cursor: 'pointer',
}));

export const StyledDivExpander = styled('div')(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
}));

export const StyledDivFileInput = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  '& > form': {
    width: '100%',
    minWidth: '120px',
  },
}));

export const StyledProgress = styled(CircularProgress)(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

export const StyledDivBoxExpandHistory = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  fontSize: '14px',
  transition: 'all 0.3s ease-out',
  '&:hover': {
    color: theme.palette.primary.main,
  },
}));
